import { AbstractControl, ValidationErrors } from "@angular/forms";

export const alphaValidator = (control: AbstractControl): ValidationErrors | null => {
  const string = control.value;
  // return /^[a-zA-Z-\s]*$/.test(string?.trim()) ? null : { alphaCharacters: string };
  return /^[A-Za-zÀ-ÖØ-öø-ÿ-\s]*$/.test(string?.trim()) ? null : { alphaCharacters: string };
};